var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a45d4f80-4d26-11f0-864e-e3123ff8def1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app@juliand-digital"]={id:"a45d4f80-4d26-11f0-864e-e3123ff8def1"};
      